const height = '100%';
const width = '16px';
export const draggableRight = {
  left: 'auto',
  right: 'auto',
  width,
  height,
  position: 'absolute',
  zIndex: '2',
  cursor: 'ew-resize',
  transform: 'translateX(8px)',
  // backgroundColor: 'rgba(255,0,0,.3)',
};

export const draggableLeft = {
  left: 'auto',
  right: 'auto',
  width,
  height,
  position: 'absolute',
  zIndex: '2',
  cursor: 'ew-resize',
  transform: 'translateX(-8px)',
  // backgroundColor: 'rgba(255,0,0,.3)',
};

export const gage = {
  left: 'auto',
  right: 'auto',
  height,
  position: 'absolute',
  zIndex: '1',
  cursor: 'move',
};



// WEBPACK FOOTER //
// ./src/components/gagebar/gagestyle.js